import { signInWithEmailAndPassword } from "firebase/auth";
import {
  clearFirebaseLocalStorage,
  initFirebase,
} from "@core/services/api/firebase";
import { apiRequest } from "@core/services/api/apiRequest";

type Args = {
  data: any;
  onError?: (error: Error) => void;
};

export async function loginUser({ data, onError }: Args) {
  const apiEndpoint = "/auth/login/";

  try {
    // Ensure firebase is initialized
    const auth = await initFirebase();

    // Login user
    const userCredential = await signInWithEmailAndPassword(
      auth,
      data.email,
      data.password
    );

    // Get user
    const user = userCredential.user;

    // Get ID token
    const idToken = await user.getIdToken();

    // Prepare data for API call
    const body = { firebase_token: idToken };

    // Send data to backend (requireAuth=false since user is logging in)
    const response = await apiRequest(apiEndpoint, "POST", body, false);

    return { authToken: idToken, ...response };
  } catch (error) {
    clearFirebaseLocalStorage();
    onError?.(error as Error);

    throw error;
  }
}

export default loginUser;
